var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.jobs.active.length > 0)?_c('b-progress',{attrs:{"max":_vm.jobs.active.length * 100}},_vm._l((_vm.jobs.active),function(job,index){return _c('b-progress-bar',{staticClass:"text-dark pl-1",attrs:{"value":job.progress,"label":job.message,"animated":"","variant":_vm.variants[index] || 'primary'}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }